import dayjs from 'dayjs';
export const WTS_MOMENT_DATE_MASK = 'YYYY-MM-DD[T]HH:mm:ss';
export const WTS_MOMENT_SHORT_DATE_MASK = 'YYYY-MM-DD';
export const WTS_MOMENT_YEAR_MONTH_MASK = 'YYYY-MM';
export const MOMENT_DEFAULT_DATE_MASK = 'DD.MM.YYYY';
export const MOMENT_MONTH_YEAR_D_MASK = 'MM.YYYY';
export const MOMENT_SHORT_DATE_MASK = 'D.M.YYYY';
export const MOMENT_MONTH_YEAR_MASK = 'MMM YYYY';
export const MOMENT_DEFAULT_LINGUAL_DATE_MASK = 'DD MMM YYYY';
export const MOMENT_DEFAULT_LINGUAL_DATE_TIME_MASK = 'DD MMM YYYY HH:mm';
export const MOMENT_DEFAULT_LINGUAL_DATE_TIME_FULL_MASK = 'DD MMM YYYY HH:mm:ss';
export const MOMENT_MIN_DATE_STRING = '0001-01-01T00:00:00';
export const MOMENT_MAX_DATE_STRING = '9999-12-31T23:59:59';
export const MOMENT_MIN_DATE = dayjs(MOMENT_MIN_DATE_STRING);
export const MOMENT_MAX_DATE = dayjs(MOMENT_MAX_DATE_STRING);
export const MOMENT_DATE_TIME_MASK = 'DD.MM.YYYY HH:mm';
export const MOMENT_DAY_MONTH_TIME_MASK = 'D.MMM HH:mm';
